// The signed-in person's own profile: its shape and the gateway's rules for it, with no network and no Firebase, so a
// page can check a form without loading either (28 Oct, the sign-in build, item 5: moved here from profile.ts, which
// re-exports them, unchanged).

export interface OwnProfile {
  firstName: string;
  lastName: string;
  companyName: string;
}

// The gateway's rules for the three fields (its steps 5 and 5b, helpers/text.helper.ts and accountProfile.service.ts),
// checked here too so sign-up refuses, before any account exists, a value the profile save would refuse. The gateway's
// check is the one that counts; this one only spares the person a profile that cannot be saved.
export const PROFILE_FIELD_MAX = 120;

/** NFC, control characters to spaces, invisible format characters removed, spaces collapsed, trimmed. */
export const cleanProfileText = (raw: string): string =>
  raw
    .normalize('NFC')
    .replace(/\p{Cc}/gu, ' ')
    .replace(/\p{Cf}/gu, '')
    .replace(/\s+/g, ' ')
    .trim();

/** The first field that breaks the rules (names 1 to 120, company 0 to 120, after cleaning), or null. */
export const profileFieldInvalid = (profile: OwnProfile): keyof OwnProfile | null => {
  if (profile.firstName.length < 1 || profile.firstName.length > PROFILE_FIELD_MAX) return 'firstName';
  if (profile.lastName.length < 1 || profile.lastName.length > PROFILE_FIELD_MAX) return 'lastName';
  if (profile.companyName.length > PROFILE_FIELD_MAX) return 'companyName';
  return null;
};
